import { combineReducers } from "redux"
import { groupBy } from "../common/common"
import { setterReducer } from "../common/redux"
import * as t from "./actionTypes"

const completed = setterReducer(false, t.SET_COMPLETED)
const completedTime = setterReducer(null, t.SET_COMPLETED_TIME)
const feedback = setterReducer("", t.SET_FEEDBACK)
const feedbackSubmitted = setterReducer(false, t.SET_SUBMITTED)
const hideFeedback = setterReducer(false, t.SET_HIDE_FEEDBACK)
const email = setterReducer("", t.SET_EMAIL)
const phoneNumber = setterReducer("", t.SET_PHONE_NUMBER)
const showTipModal = setterReducer(false, t.SET_SHOW_TIP_MODAL)
const isAlarm = setterReducer(false, t.SET_IS_ALARM)

const showFollowUpModal = (state = { show: false, shown: false }, action) => {
  switch (action.type) {
    case t.SET_SHOW_FOLLOW_UP_MODAL:
      return { show: action.payload, shown: true }
    default:
      return state
  }
}

const showFollowUpCard = (state = { show: false }, action) => {
  switch (action.type) {
    case t.SET_SHOW_FOLLOW_UP_CARD:
      return { show: action.payload }
    default:
      return state
  }
}

const results = (state = {}, action) => {
  let newDiff
  switch (action.type) {
    case t.SET_RESULTS:
      if (
        Object.keys(action.results).length === 0 &&
        action.results.constructor === Object
      ) {
        return action.results
      }
      let triageMap = groupBy(action.results.differential, "triage")
      let triageInfo = Object.keys(triageMap).map(key => ({
        triage: key,
        diagnoses: triageMap[key].map(d => d.diagnosis),
      }))

      triageInfo.forEach((info, i) => {
        if (info.triage === action.results.triage.short) {
          triageInfo = [...triageInfo.splice(i, 1), ...triageInfo]
        }
      })
      return { triageInfo, ...action.results }
    case t.SET_DIAGNOSIS_EXPAND:
      newDiff = [...state.differential]
      newDiff[action.index].expanded = !newDiff[action.index].expanded
      return { ...state, differential: newDiff }
    case t.SET_DIAGNOSIS_AGREEMENT:
      newDiff = [...state.differential]
      newDiff[action.index].agree = action.agree
      if (!action.agree) {
        newDiff = newDiff.map(diag => ({ ...diag, showFeedback: false }))
        newDiff[action.index].showFeedback = !state.feedbackSubmitted
      }
      return { ...state, differential: newDiff }
    case t.SET_DIAGNOSIS_HELPFULNESS:
      newDiff = [...state.differential]
      newDiff[action.index].helpful = action.agree
      return { ...state, differential: newDiff }
    default:
      return state
  }
}

const profInt = {
  email: "",
  error: null,
  attempted: false,
  submitted: false,
  showConfirmation: false,
}

const profileInterest = (state = profInt, action) => {
  switch (action.type) {
    case t.SET_PROFILE_INTEREST_SUBMITTED:
      return { ...state, submitted: action.payload }
    case t.SET_PROFILE_INTEREST_EMAIL:
      return { ...state, email: action.payload }
    case t.SET_PROFILE_INTEREST_ERROR:
      return { ...state, error: action.payload }
    case t.SET_PROFILE_INTEREST_ATTEMPTED:
      return { ...state, attempted: action.payload }
    case t.SHOW_PROFILE_INTEREST_CONFIRMATION:
      return { ...state, showConfirmation: action.payload }
    default:
      return state
  }
}

const completion = combineReducers({
  completed,
  completedTime,
  email,
  feedback,
  feedbackSubmitted,
  hideFeedback,
  phoneNumber,
  profileInterest,
  results,
  isAlarm,
  showFollowUpModal,
  showFollowUpCard,
  showTipModal,
})

export { completion as default }



// WEBPACK FOOTER //
// ./assets/completion/reducer.js